import React from 'react';
import { wrapHorizontalScrollView } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/horizontal-scrolling';
import TableGroup from '../table-group';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export default function StickyTableGroup({ scope, zoomLevel, width, stickyHeader }: Props) {
	if (!stickyHeader) return null;
	const item = scope[stickyHeader.index];

	// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
	const content = <TableGroup item={item} width={width} style={{ height: '100%' }} />;

	return zoomLevel ? (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.stickyHeaderSprintsContainer}>{wrapHorizontalScrollView(content)}</div>
	) : (
		content
	);
}
